@if (isLoading) {
	<app-loading
		(initGame)="initGame()"
	/>
} @else {
		<app-game class="relative h-dvh w-dvw"/>
		@if (infoModalVisible && currentType) {
			<app-result-modal-with-actions
				[type]="'any'"
				[modalTitle]="modalInfo[currentType]?.title"
				[modalDescription]="modalInfo[currentType]?.description"
				[modalBtnAccess]="'Войти'"
				[modalBtnReject]="'Не сейчас'"
				[bgClass]="currentType"
				(rejectClicked)="closeInfoModal()"
				(successClicked)="openGameModal()"
			></app-result-modal-with-actions>
		}
		<ng-container #container></ng-container>
}